import { GetObjectAttributesCommand, GetObjectCommand, GetObjectTaggingCommand, ListObjectsCommand, PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { Amplify, Auth } from 'aws-amplify';
import { awsExports } from '../aws-exports';
import { getAuthData } from "./ExperimentDAO";
import * as moment from 'moment';


Amplify.configure({
  Auth: {
    region: awsExports.REGION,
    userPoolId: awsExports.USER_POOL_ID,
    userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
    identityPoolId: awsExports.IDENTITY_POOL_ID
  }
});

let client = null;
let cache = {};
let verbose = false;

export const getClient = async () => {
  if (client) {
    return client;
  }

  if (verbose) console.log("Creating S3 client");
  let params = {
    region: awsExports.REGION,
    credentials: Auth.essentialCredentials(await Auth.currentCredentials())
  }
  client = new S3Client(params);
  return client;
}

export const parseJwt = (token) => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export const sendCommand = async (command) => {
  await Auth.currentSession();
  let client = await getClient();
  let data = await client.send(command);
  return data;
}

export const pushNewS3Object = async (key, body) => {
  if (key in cache) {
    if (cache[key].length === body.length) {
      return 200;  
    } else {
      if (verbose) console.log('Comparing cache current for push = ' + cache[key].length + ' compared to new = ' + body.length );
      if (verbose) console.log('Updating cache for object from push\n', key);
    }
  }

  let upload = await sendCommand(new PutObjectCommand({
    Bucket: awsExports.BUCKET_NAME,
    Key: key,
    Body: body,
    CacheControl: "no-cache"
  }));

  let statusCode = upload.$metadata.httpStatusCode;

  if (statusCode === 200) {
    if (verbose) console.log("Put object and updated cache for it.\n", key, body);
    cache[key] = body;
  }

  return statusCode;
}

const checkObjSize = async (key) => {

  let data = await sendCommand(new GetObjectAttributesCommand({
    Bucket: awsExports.BUCKET_NAME,
    Key: key,
    ObjectAttributes: ["ObjectSize"]
  }));
  return data.ObjectSize;
}

export const getS3Object = async (key) => {
  if (key in cache) {
    const objSize = await checkObjSize(key)
    if (cache[key].length === objSize) {
      return cache[key];  
    } else {
      if (verbose) console.log('Comparing cache current for get = ' + cache[key].length + ' compared to new = ' + objSize );
      if (verbose) console.log('Updating cache for object from get\n', key);
    }
  }

  let data = await sendCommand(new GetObjectCommand({
    Bucket: awsExports.BUCKET_NAME,
    Key: key,
  }));
  let dataStr = data !== null ? await data.Body.transformToString() : null;
  cache[key] = dataStr;
  return dataStr;
}

export const getS3ObjectTags = async (key) => {
  let data = await sendCommand(new GetObjectTaggingCommand({
    Bucket: awsExports.BUCKET_NAME,
    Key: key
  }));
  return data;
}

export const listS3Objects = async (prefix = null) => {
  if (prefix == null) {
    prefix = await getAuthData();
  }

  let data = await sendCommand(new ListObjectsCommand({
    Bucket: awsExports.BUCKET_NAME,
    Prefix: prefix
  }));
  return data.Contents;
}

export const parseCsvString = (bufferString) => {
  let arr = bufferString.split('\n');
  let jsonObj = [];
  let headers = arr[0].split(',');
  for (let i = 1; i < arr.length; i++) {
    let data = arr[i].split(',');
    let obj = {};
    for (let j = 0; j < data.length; j++) {
      obj[headers[j].trim()] = data[j].trim();
    }
    jsonObj.push(obj);
  }
  return jsonObj
}

export const parseJsonString = (bufferString) => {
  return JSON.parse(bufferString);
}

export const parseMillisToString = (millis) => {
  return millis ? moment(new Date(millis)).format('MMM D, YYYY h A') : null;
}

export const parseMillisDifference = (ms) => {
  let seconds = (ms / 1000).toFixed(1);
  let minutes = (ms / (1000 * 60)).toFixed(1);
  let hours = (ms / (1000 * 60 * 60)).toFixed(1);
  let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
  if (seconds < 60) return seconds + " Sec";
  else if (minutes < 60) return minutes + " Min";
  else if (hours < 24) return hours + " Hrs";
  else return days + " Days"
}

export const cacheData = (key, data) => {
  cache[key] = data;
}

export const getFromCache = (key) => {
  if (key in cache) { return cache[key]; }
  else { return null; }
}

export const getCache = () => {
  return cache;
}

export const clearCache = () => {
  if (verbose) console.log('clearing cache');
  client = null;
  cache = {};
}

export const logCache = () => {
  console.log(cache);
}
